<template>
  <Icon-Template :size="size">
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
      <path d="M437.019 74.98C388.667 26.629 324.38 0 256 0C187.619 0 123.331 26.629 74.98 74.98C26.628 123.332 0 187.62 0 256C0 324.38 26.628 388.667 74.98 437.019C123.332 485.371 187.619 512 256 512C324.38 512 388.667 485.371 437.019 437.019C485.371 388.667 512 324.38 512 256C512 187.62 485.371 123.333 437.019 74.98ZM256 482C131.383 482 30 380.617 30 256C30 131.383 131.383 30 256 30C380.617 30 482 131.383 482 256C482 380.617 380.617 482 256 482Z"/>
      <path d="M378.305 173.859C372.448 168.003 362.95 168.003 357.093 173.86L224.634 306.319L154.907 236.592C149.05 230.735 139.552 230.735 133.694 236.592C127.836 242.449 127.836 251.947 133.694 257.805L214.027 338.138C216.956 341.067 220.795 342.531 224.633 342.531C228.471 342.531 232.311 341.066 235.239 338.138L378.305 195.072C384.163 189.215 384.163 179.717 378.305 173.859Z"/>
    </svg>
  </Icon-Template>
</template>

<script>

import IconTemplate from '@/components/icons/Template'

export default {
  props: ['size'],
  components: { IconTemplate }
}
</script>